import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IKnmErknmFormEventUav } from '../interfaces/IKnmErknmFormUav';

export const getEventUavValidator = (
  uavTechnologies: IKnmErknmFormEventUav[] | undefined,
  isKnmStatusTypeCompleted?: boolean,
): FormErrors<IKnmErknmFormEventUav>[] | string | undefined => {
  if ((!uavTechnologies || !uavTechnologies?.length) && !isKnmStatusTypeCompleted) {
    return 'Поле не может быть пустым';
  }

  return uavTechnologies?.map(item => ({
    name: makeRequired(REQUIRED_ERROR)(item.name),
    type: makeRequired(REQUIRED_ERROR)(item.type),
  }));
};
